import { c as _c } from "react/compiler-runtime";
import SvgChevronright from '@common/icon/SvgChevronright';
import { cn } from '@core/utils';
import type { ReactNode } from 'react';
import { CustomLink } from '@/app/_components/CustomLink';
interface GoodsSectionHeaderProps {
  eyebrow?: string;
  title: ReactNode;
  description?: ReactNode;
  moreHref?: string;
  moreAriaLabel?: string;
  moreClassName?: string;
  className?: string;
}
export const GoodsSectionHeader = t0 => {
  const $ = _c(25);
  const {
    eyebrow,
    title,
    description,
    moreHref,
    moreAriaLabel,
    moreClassName,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex w-full flex-col gap-4 px-40 content-container", "mobile-tablet:px-20", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== eyebrow) {
    t2 = eyebrow ? <p className="font-600 text-O-400 typo-body3 mobile-tablet:typo-caption1">{eyebrow}</p> : null;
    $[2] = eyebrow;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== title) {
    t3 = <h2 className="font-700 text-Gray-900 typo-h5 mobile-tablet:tracking-[-0.02em] mobile-tablet:typo-h7">{title}</h2>;
    $[4] = title;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== description) {
    t4 = description ? <p className="text-Gray-500 typo-body3 mobile-tablet:hidden">{description}</p> : null;
    $[6] = description;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <div className="flex min-w-0 items-baseline gap-12">{t3}{t4}</div>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== moreAriaLabel || $[12] !== moreClassName || $[13] !== moreHref) {
    t6 = moreHref ? <CustomLink prefetch={false} href={moreHref} aria-label={moreAriaLabel} className={cn("group -m-8 flex shrink-0 items-center gap-4 rounded-xxsmall p-8 text-Gray-900", "transition-colors duration-150 hover:text-Gray-black active:text-Gray-black motion-reduce:transition-none", "focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-B-500", moreClassName)}><span className="font-500 typo-body3 group-hover:underline mobile-tablet:sr-only">전체보기</span><SvgChevronright className="size-16 text-Gray-500 transition-transform duration-150 group-hover:translate-x-1 group-focus-visible:translate-x-1 mobile-tablet:size-20 motion-reduce:transition-none" /></CustomLink> : null;
    $[11] = moreAriaLabel;
    $[12] = moreClassName;
    $[13] = moreHref;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t5 || $[16] !== t6) {
    t7 = <div className="flex w-full items-center justify-between gap-12">{t5}{t6}</div>;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== description) {
    t8 = description ? <p className="hidden text-Gray-500 typo-caption1 mobile-tablet:block">{description}</p> : null;
    $[18] = description;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t1 || $[21] !== t2 || $[22] !== t7 || $[23] !== t8) {
    t9 = <header className={t1}>{t2}{t7}{t8}</header>;
    $[20] = t1;
    $[21] = t2;
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  return t9;
};